import React, { useEffect, useState, createElement } from 'react';
import { Header } from '../components/heylloyd/Header';
import { StepSection } from '../components/heylloyd/StepSection';
import { LloydCard } from '../components/heylloyd/LloydCard';
import { DecisionGuide } from '../components/heylloyd/DecisionGuide';
import { SundayCountdownTimer } from '../components/SundayCountdownTimer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { ShoppingCart, Monitor, Bot, Check, X, Zap, Clock, Rocket, ChevronDown, Users, Video, Calendar } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
export function WebinarReplyPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };
  useEffect(() => {
    // Load Wistia scripts immediately for instant video playback
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/zp6fg5q0oy.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    const style = document.createElement('style');
    style.textContent = `
      wistia-player[media-id='zp6fg5q0oy']:not(:defined) { 
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/zp6fg5q0oy/swatch'); 
        display: block; 
        filter: blur(5px); 
        padding-top:56.25%; 
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(embedScript);
      document.head.removeChild(style);
    };
  }, []);
  const faqs = [{
    question: '¿Qué incluye exactamente 48/hrs AI Cash Machine?',
    answer: 'Obtienes acceso instantáneo a todos los Custom Lloyds especializados y el sistema paso a paso completo. Además, recibirás guías detalladas, acceso al grupo privado de Facebook, y llamadas mensuales en vivo con Gabriel Beltran. Nota: HeyLloyd es un software mensual separado ($20/mes con plan anual o $40/mes con plan mensual) que necesitarás para usar los Custom Lloyds.'
  }, {
    question: '¿Realmente puedo crear un producto en 48 horas sin experiencia?',
    answer: 'Sí. Los Custom Lloyds te guían paso a paso en cada tarea. No necesitas conocimientos técnicos, de diseño o marketing. El sistema te dice exactamente qué hacer en cada momento, eliminando la curva de aprendizaje.'
  }, {
    question: '¿Qué es el grupo privado de Facebook?',
    answer: 'Es una comunidad exclusiva para miembros de 48/hrs AI Cash Machine donde puedes conectar con otros emprendedores, compartir experiencias, hacer preguntas y recibir apoyo constante en tu proceso de creación y lanzamiento.'
  }, {
    question: '¿Cómo funcionan las llamadas mensuales con Gabriel Beltran?',
    answer: 'Cada mes, un lunes, Gabriel Beltran realiza una llamada en vivo exclusiva para miembros donde responde preguntas, comparte estrategias actualizadas y te ayuda a escalar tu negocio. Estas sesiones son grabadas por si no puedes asistir en vivo.'
  }, {
    question: '¿Qué pasa si no completo todo en 48 horas?',
    answer: 'No hay problema. 48 horas es el tiempo estimado siguiendo el sistema paso a paso, pero tienes acceso de por vida a todos los Custom Lloyds y recursos. Puedes ir a tu propio ritmo.'
  }, {
    question: '¿Necesito pagar por HeyLloyd por separado?',
    answer: 'Sí, HeyLloyd es un software mensual que se paga por separado. Cuesta $20/mes si pagas anualmente o $40/mes si pagas mensualmente. HeyLloyd es la plataforma que ejecuta los Custom Lloyds en tu computadora. Los Custom Lloyds especializados están incluidos en 48/hrs AI Cash Machine.'
  }, {
    question: '¿Funciona en Mac y Windows?',
    answer: 'Sí, HeyLloyd funciona tanto en Mac como en Windows. El sistema se adapta a tu computadora y funciona de la misma manera en ambas plataformas.'
  }, {
    question: '¿Hay garantía de devolución?',
    answer: 'Sí, ofrecemos una garantía de satisfacción de 30 días. Si no estás satisfecho con el producto, puedes solicitar un reembolso completo dentro de los primeros 30 días.'
  }];
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-3321">
      <Header data-id="element-3322" />

      {/* Hero Section - Webinar Replay with Video */}
      <section className="pt-14 md:pt-16 py-6 md:py-10 bg-gradient-to-b from-gray-900 to-black" data-id="element-3323">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-3324">
          {/* Replay Badge */}
          <div className="text-center mb-5" data-id="element-3325"></div>

          {/* Headline */}
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-black text-white mb-3 md:mb-5 leading-tight text-center tracking-tight" data-id="element-3326">
            48/hrs AI Cash Machine
          </h1>

          <p className="text-base md:text-lg text-gray-100 mb-5 md:mb-7 max-w-3xl mx-auto leading-relaxed text-center" data-id="element-3327">
            El sistema completo que te guía paso a paso para crear y lanzar tu
            producto digital con IA en menos de 48 horas
          </p>

          {/* Video Player */}
          <div className="mb-8 md:mb-10" data-id="element-3328">
            <div className="w-full max-w-4xl mx-auto overflow-hidden border border-cyan-500 relative" style={{
            boxShadow: '0 0 40px rgba(6, 182, 212, 0.4), 0 0 80px rgba(6, 182, 212, 0.2)'
          }} data-id="element-3329">
              <wistia-player media-id="zp6fg5q0oy" aspect="1.7777777777777777" data-id="element-3330"></wistia-player>
            </div>
          </div>

          {/* CTA Button */}
          <div className="text-center mb-8" data-id="element-3331">
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" data-id="element-3332">
              <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-2xl text-lg md:text-xl py-5 md:py-6 px-8 md:px-12" leftIcon={<ShoppingCart className="w-6 h-6" data-id="element-3334" />} data-id="element-3333">
                Comprar Ahora - Acceso Inmediato
              </Button>
            </a>
          </div>

          {/* Countdown Timer */}
          <div className="max-w-2xl mx-auto" data-id="element-3335">
            <SundayCountdownTimer data-id="element-3336" />
          </div>
        </div>
      </section>

      {/* Value Proposition Section */}
      <section className="py-10 md:py-14 bg-black" data-id="element-3337">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-3338">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl shadow-2xl p-5 md:p-8 border border-gray-700" data-id="element-3339">
            <div className="flex items-center justify-center gap-3 mb-3" data-id="element-3340">
              <Zap className="w-7 h-7 md:w-9 md:h-9 text-yellow-500" data-id="element-3341" />
              <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-3342">
                Incluso si no tienes experiencia
              </h3>
            </div>
            <p className="text-base md:text-lg text-gray-100 text-center leading-relaxed" data-id="element-3343">
              El sistema paso a paso con Custom Lloyds especializados te guiará
              en cada paso del proceso para que puedas estar en vivo en 48 horas
              o menos
            </p>
          </div>
        </div>
      </section>

      {/* PASO 1 */}
      <div id="paso-1" data-id="element-3344">
        <StepSection stepNumber="1" title="Obtén acceso inmediato a todos los Custom Lloyds" data-id="element-3345">
          <p className="text-lg md:text-xl text-gray-400 mb-6 md:mb-8" data-id="element-3346">
            Al adquirir 48/hrs AI Cash Machine, obtendrás acceso instantáneo a
            todos los Custom Lloyds especializados y el sistema paso a paso
            completo que te guiará en cada etapa.
          </p>

          <div className="mb-8 md:mb-10" data-id="element-3347">
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" data-id="element-3348">
              <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-lg hover:shadow-xl" leftIcon={<ShoppingCart className="w-5 h-5" data-id="element-3350" />} data-id="element-3349">
                Comprar Ahora - Acceso Inmediato
              </Button>
            </a>
          </div>

          <div className="bg-gradient-to-r from-cyan-900 to-blue-900 rounded-xl p-6 md:p-8 border border-cyan-700 mb-6" data-id="element-3351">
            <h4 className="font-bold text-white mb-4 text-lg flex items-center gap-2" data-id="element-3352">
              <Rocket className="w-6 h-6 text-cyan-400" data-id="element-3353" />
              Lo que obtienes inmediatamente:
            </h4>
            <div className="space-y-3" data-id="element-3354">
              {['Acceso instantáneo a todos los Custom Lloyds especializados', 'Sistema paso a paso completo para crear tu producto', 'Guías detalladas para cada etapa del proceso', 'Acceso al grupo privado de Facebook', 'Llamadas mensuales en vivo con Gabriel Beltran', 'Soporte prioritario para implementación'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-3355">
                  <Check className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-3356" />
                  <span className="text-gray-200" data-id="element-3357">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="bg-cyan-900/70 border border-cyan-500 rounded-xl p-4 md:p-6" data-id="element-3358">
            <p className="text-white text-sm md:text-base" data-id="element-3359">
              <strong className="text-cyan-100" data-id="element-3360">Nota importante:</strong> Para
              usar los Custom Lloyds, necesitarás HeyLloyd, un software mensual
              que se paga por separado ($20/mes con plan anual o $40/mes con
              plan mensual). HeyLloyd es la plataforma que ejecuta los Custom
              Lloyds en tu computadora.
            </p>
          </div>
        </StepSection>
      </div>

      {/* PASO 2 */}
      <div id="paso-2" data-id="element-3361">
        <StepSection stepNumber="2" title="Usa HeyLloyd para ejecutar los Custom Lloyds" bgColor="gray" data-id="element-3362">
          <p className="text-lg md:text-xl text-slate-800 mb-4 md:mb-6" data-id="element-3363">
            HeyLloyd es el software que ejecuta los Custom Lloyds. Es una
            superposición de escritorio transparente que se coloca sobre tu
            pantalla y te guía en tiempo real:
          </p>
          <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8" data-id="element-3364">
            <div className="bg-white p-4 md:p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-3365">
              <Monitor className="w-7 h-7 md:w-8 md:h-8 text-cyan-600 mb-3 md:mb-4" data-id="element-3366" />
              <h4 className="font-bold text-slate-900 mb-1 md:mb-2 text-sm md:text-base" data-id="element-3367">
                Trabaja como siempre
              </h4>
              <p className="text-slate-600 text-xs md:text-sm" data-id="element-3368">
                Ves tu computadora normal, pero ahora con los Custom Lloyds
                guiándote paso a paso.
              </p>
            </div>
            <div className="bg-white p-4 md:p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-3369">
              <Bot className="w-7 h-7 md:w-8 md:h-8 text-cyan-600 mb-3 md:mb-4" data-id="element-3370" />
              <h4 className="font-bold text-slate-900 mb-1 md:mb-2 text-sm md:text-base" data-id="element-3371">
                Asistencia en tiempo real
              </h4>
              <p className="text-slate-600 text-xs md:text-sm" data-id="element-3372">
                Los Custom Lloyds ven lo que tú ves y te dan instrucciones
                precisas para cada tarea.
              </p>
            </div>
          </div>

          <div className="bg-cyan-900/70 border border-cyan-500 rounded-xl p-4 md:p-6 mb-6" data-id="element-3373">
            <h4 className="font-bold text-white mb-3 text-base md:text-lg flex items-center gap-2" data-id="element-3374">
              <Check className="w-5 h-5 text-cyan-300" data-id="element-3375" />
              Precios de HeyLloyd (software mensual):
            </h4>
            <div className="space-y-2 text-white text-sm md:text-base" data-id="element-3376">
              <div className="flex items-center gap-2" data-id="element-3377">
                <Check className="w-4 h-4 text-cyan-300 flex-shrink-0" data-id="element-3378" />
                <span data-id="element-3379">
                  <strong className="text-cyan-100" data-id="element-3380">Plan Anual:</strong> $20/mes
                  (facturado anualmente)
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-3381">
                <Check className="w-4 h-4 text-cyan-300 flex-shrink-0" data-id="element-3382" />
                <span data-id="element-3383">
                  <strong className="text-cyan-100" data-id="element-3384">Plan Mensual:</strong>{' '}
                  $40/mes (facturado mensualmente)
                </span>
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 md:p-6 rounded-r-lg" data-id="element-3385">
            <p className="font-bold text-slate-900 mb-2 flex items-center gap-2" data-id="element-3386">
              <Clock className="w-5 h-5 text-yellow-600" data-id="element-3387" />
              ¿Por qué 48 horas?
            </p>
            <p className="text-slate-700 text-sm md:text-base" data-id="element-3388">
              Porque los Custom Lloyds eliminan la curva de aprendizaje. No
              necesitas saber de tecnología, diseño o marketing. El sistema te
              dice exactamente qué hacer en cada momento, permitiéndote
              completar en 48 horas lo que normalmente tomaría semanas o meses.
            </p>
          </div>
        </StepSection>
      </div>

      {/* PASO 3 */}
      <div id="paso-3" data-id="element-3389">
        <StepSection stepNumber="3" title="Usa los Custom Lloyds especializados" data-id="element-3390">
          <p className="text-slate-800 mb-4 md:mb-6 text-sm md:text-base" data-id="element-3391">
            Cada <strong data-id="element-3392">Custom Lloyd</strong> es un bot especializado que te
            guía en una tarea específica del proceso. Desde crear tu producto
            hasta escribir el copy de ventas, cada Lloyd está pre-configurado
            para llevarte de la mano.
          </p>
          <div className="bg-slate-50 rounded-xl p-4 md:p-6 border border-slate-200 mb-6 md:mb-8" data-id="element-3393">
            <h4 className="font-bold text-slate-900 mb-3 md:mb-4 text-sm md:text-base" data-id="element-3394">
              Cómo funciona el sistema:
            </h4>
            <ol className="list-decimal list-inside space-y-2 text-slate-800 text-sm md:text-base" data-id="element-3395">
              <li data-id="element-3396">Seleccionas el Lloyd que necesitas para tu tarea actual</li>
              <li data-id="element-3397">HeyLloyd carga ese bot especializado</li>
              <li data-id="element-3398">
                Sigues las instrucciones paso a paso que aparecen en tu pantalla
              </li>
              <li data-id="element-3399">Completas la tarea y pasas al siguiente Lloyd</li>
            </ol>
          </div>
          <div className="space-y-2" data-id="element-3400">
            <h4 className="font-bold text-slate-900 text-sm md:text-base" data-id="element-3401">
              Todo está diseñado para que:
            </h4>
            <ul className="space-y-2 text-slate-800 text-sm md:text-base" data-id="element-3402">
              <li className="flex items-center" data-id="element-3403">
                <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full mr-2" data-id="element-3404" />
                No necesites conocimientos técnicos previos
              </li>
              <li className="flex items-center" data-id="element-3405">
                <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full mr-2" data-id="element-3406" />
                No tengas que pensar en qué hacer después
              </li>
              <li className="flex items-center" data-id="element-3407">
                <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full mr-2" data-id="element-3408" />
                Puedas completar todo el proceso en 48 horas o menos
              </li>
            </ul>
          </div>
        </StepSection>
      </div>

      {/* GALLERY - Custom Lloyds incluidos */}
      <section id="gallery" className="py-12 md:py-20 bg-slate-50 border-t border-slate-200" data-id="element-3409">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-3410">
          <div className="text-center mb-10 md:mb-16" data-id="element-3411">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mb-3 md:mb-4 px-2" data-id="element-3412">
              Custom Lloyds Incluidos en 48/hrs AI Cash Machine
            </h2>
            <p className="text-slate-800 max-w-2xl mx-auto text-sm md:text-base px-2" data-id="element-3413">
              Todos estos Custom Lloyds especializados están incluidos y listos
              para guiarte en cada paso del proceso
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-12" data-id="element-3414">
            <LloydCard title="AI Product Builder" subtitle="Construcción de productos con IA" description="Tu asistente completo para crear productos digitales desde cero. HeyLloyd te guía en cada paso: desde la idea inicial hasta el lanzamiento, ayudándote a construir productos profesionales sin experiencia técnica." imageSrc="https://cdn.magicpatterns.com/uploads/pXDmn28qLnCMrUYkdpGPpS/hf_20260116_225721_4dc7f3c1-48e8-4206-b7a5-3ddf70d36f02.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-3415" />
            <LloydCard title="Ebook Writer" subtitle="Escritura de ebooks" description="Perfecto para crear ebooks completos desde cero. HeyLloyd te guiará en la estructura, capítulos, y contenido para que escribas tu ebook paso a paso, directamente en tu pantalla." imageSrc="https://cdn.magicpatterns.com/uploads/mZHQRarDkUFPHSnnRgrYNx/heylloyd-image-1768596398723.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-3416" />
            <LloydCard title="Ebook Cover Designer" subtitle="Diseño de portadas" description="Especializado en crear portadas profesionales y atractivas para tus ebooks. HeyLloyd te guía en el diseño visual, tipografía y elementos gráficos para que tu ebook destaque y atraiga lectores." imageSrc="https://cdn.magicpatterns.com/uploads/95YcbtScePy8FYnqxtUWrb/hf_20260116_225742_c84c2966-04d0-407a-8eb3-53f8e6f29bab.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-3417" />
            <LloydCard title="Identity Persuasion Copywriter" subtitle="Copy persuasivo" description="Especializado en crear copy que conecta con la identidad de tu audiencia. Ideal para escribir mensajes que persuaden, venden y generan conversiones con técnicas de copywriting avanzadas." imageSrc="https://cdn.magicpatterns.com/uploads/mSU1vsY4XXAQMJDxHLq9tK/heylloyd-image-1768596505790.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-3418" />
            <LloydCard title="Sales Letter Weapon" subtitle="Cartas de ventas" description="Tu arma secreta para crear sales letters que convierten. HeyLloyd te ayudará a estructurar y escribir cartas de ventas persuasivas que generan resultados reales." imageSrc="https://cdn.magicpatterns.com/uploads/5Vbgxv8pJwQBoVv72Jwat3/heylloyd-image-1768596561791.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-3419" />
            <LloydCard title="Meta Ads Decision Engine" subtitle="Optimización de anuncios" description="Motor de decisiones para tus campañas de Meta Ads. HeyLloyd te ayuda a analizar, optimizar y tomar decisiones estratégicas sobre tus anuncios de Facebook e Instagram en tiempo real." imageSrc="https://cdn.magicpatterns.com/uploads/uX7GKZjLzcZHYruWJanCH7/heylloyd-image-1768596648758.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-3420" />
            <LloydCard title="The Viral PDF Lab" subtitle="PDFs virales" description="Laboratorio especializado en crear PDFs que se comparten masivamente. Ideal para lead magnets, recursos descargables y contenido que tu audiencia querrá compartir una y otra vez." imageSrc="https://cdn.magicpatterns.com/uploads/wRK7DAN3h4pP5mk1SskSzS/heylloyd-image-1768596692126.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-3421" />
            <LloydCard title="AI Complete Brand Operation System" subtitle="Sistema de marca completo" description="Sistema operativo completo para tu marca con IA. Desde estrategia hasta ejecución, HeyLloyd te guía en todos los aspectos de construcción y operación de tu marca de forma integrada." imageSrc="https://cdn.magicpatterns.com/uploads/i1MwR9sTfLGqX1o8cqMy9E/heylloyd-image-1768596733993.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="INCLUIDO" data-id="element-3422" />
          </div>
          <div className="text-center bg-gradient-to-r from-cyan-50 to-blue-50 p-6 md:p-8 rounded-xl border-2 border-cyan-200 max-w-3xl mx-auto shadow-lg" data-id="element-3423">
            <h4 className="font-bold text-slate-900 mb-3 text-xl flex items-center justify-center gap-2" data-id="element-3424">
              <Zap className="w-6 h-6 text-yellow-500" data-id="element-3425" />
              Todos los Custom Lloyds incluidos en 48/hrs AI Cash Machine
            </h4>
            <p className="text-slate-800 mb-4" data-id="element-3426">
              Obtienes acceso instantáneo a todos estos Custom Lloyds
              especializados y el sistema paso a paso completo. Los Custom
              Lloyds se ejecutan en HeyLloyd (software mensual separado: $20/mes
              anual o $40/mes mensual).
            </p>
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" data-id="element-3427">
              <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-xl" leftIcon={<ShoppingCart className="w-5 h-5" data-id="element-3429" />} data-id="element-3428">
                Obtener Acceso a Todos los Custom Lloyds
              </Button>
            </a>
          </div>
        </div>
      </section>

      <DecisionGuide data-id="element-3430" />

      {/* FAQ Section */}
      <section className="py-12 md:py-20 bg-white" data-id="element-3431">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-3432">
          <div className="text-center mb-10 md:mb-16" data-id="element-3433">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-3434">
              Preguntas Frecuentes
            </h2>
            <p className="text-lg text-slate-800" data-id="element-3435">
              Encuentra respuestas a las preguntas más comunes sobre 48/hrs AI
              Cash Machine
            </p>
          </div>

          {/* Community & Support Highlight */}
          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-3436">
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 border border-blue-200" data-id="element-3437">
              <div className="flex items-center gap-3 mb-3" data-id="element-3438">
                <div className="bg-blue-500 rounded-full p-2" data-id="element-3439">
                  <Users className="w-6 h-6 text-white" data-id="element-3440" />
                </div>
                <h3 className="font-bold text-slate-900 text-lg" data-id="element-3441">
                  Grupo Privado de Facebook
                </h3>
              </div>
              <p className="text-slate-700 text-sm" data-id="element-3442">
                Acceso exclusivo a nuestra comunidad privada donde puedes
                conectar con otros miembros, compartir experiencias y recibir
                apoyo constante.
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 border border-purple-200" data-id="element-3443">
              <div className="flex items-center gap-3 mb-3" data-id="element-3444">
                <div className="bg-purple-500 rounded-full p-2" data-id="element-3445">
                  <Video className="w-6 h-6 text-white" data-id="element-3446" />
                </div>
                <h3 className="font-bold text-slate-900 text-lg" data-id="element-3447">
                  Llamadas Mensuales en Vivo
                </h3>
              </div>
              <p className="text-slate-700 text-sm" data-id="element-3448">
                Cada mes, un lunes, Gabriel Beltran realiza una sesión en vivo
                para ayudarte a escalar tu negocio y responder tus preguntas.
              </p>
            </div>
          </div>

          <div className="space-y-4" data-id="element-3449">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-md border border-slate-200 overflow-hidden transition-all duration-300 hover:shadow-lg" data-id="element-3450">
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 transition-colors duration-200 hover:bg-slate-50" data-id="element-3451">
                  <span className="text-lg font-semibold text-slate-900 pr-4" data-id="element-3452">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-cyan-600 flex-shrink-0 transition-transform duration-300 ${openFaqIndex === index ? 'rotate-180' : ''}`} data-id="element-3453" />
                </button>
                <div className={`transition-all duration-300 ease-in-out ${openFaqIndex === index ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`} data-id="element-3454">
                  <div className="px-6 pb-5 pt-2" data-id="element-3455">
                    <p className="text-slate-700 leading-relaxed" data-id="element-3456">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="mt-12 text-center bg-gradient-to-r from-cyan-50 to-blue-50 p-6 rounded-xl border border-cyan-200" data-id="element-3457">
            <p className="text-slate-800 mb-4" data-id="element-3458">
              ¿Tienes más preguntas? Contáctanos directamente:
            </p>
            <a href="mailto:support@truemarketer.com" className="text-cyan-600 hover:text-cyan-700 font-semibold underline" data-id="element-3459">
              support@truemarketer.com
            </a>
          </div>
        </div>
      </section>

      {/* Book a Call Section */}
      <section className="py-12 md:py-20 bg-gradient-to-b from-white to-slate-50" data-id="element-3460">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-3461">
          <div className="bg-gradient-to-r from-cyan-500 to-blue-500 rounded-xl p-8 md:p-12 text-center shadow-2xl" data-id="element-3462">
            <Calendar className="w-12 h-12 md:w-16 md:h-16 text-white mx-auto mb-6" data-id="element-3463" />
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-white mb-4" data-id="element-3464">
              ¿Necesitas Ayuda Para Empezar?
            </h2>
            <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-3465">
              Duración: 20-30 minutos
              <br data-id="element-3466" />
              <br data-id="element-3467" />
              Tiempo suficiente para conocerte
            </p>
            <a href="https://api.leadconnectorhq.com/widget/bookings/info-commerce-llamada-de-claridad-crea-tu-producto-digital-con-ia" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-cyan-600 px-8 md:px-12 py-4 md:py-5 rounded-full font-bold text-lg md:text-xl hover:bg-gray-50 hover:scale-105 transition-all duration-300 shadow-xl" data-id="element-3468">
              Reservar Llamada de Claridad
            </a>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-12 md:py-20 bg-gradient-to-b from-white to-cyan-50" data-id="element-3469">
        <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-3470">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-6" data-id="element-3471">
            Empieza tu 48/hrs AI Cash Machine hoy
          </h2>
          <p className="text-xl text-slate-800 mb-8 max-w-2xl mx-auto" data-id="element-3472">
            Acceso inmediato a HeyLloyd y todos los Custom Lloyds. Comienza a
            construir tu producto digital ahora mismo.
          </p>
          <a href="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" target="_blank" rel="noopener noreferrer" data-id="element-3473">
            <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-2xl text-xl py-6 px-12" leftIcon={<ShoppingCart className="w-6 h-6" data-id="element-3475" />} data-id="element-3474">
              Comprar Ahora - Acceso Instantáneo
            </Button>
          </a>
          <p className="text-sm text-slate-500 mt-4" data-id="element-3476">
            Garantía de satisfacción de 30 días
          </p>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-3477" />

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-3478">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-3479">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-3480">
              <X className="w-6 h-6" data-id="element-3481" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-3482">
              Términos y Condiciones
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-3483">
              <p data-id="element-3484">
                Al adquirir 48/hrs AI Cash Machine, aceptas los siguientes
                términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3485">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-3486">
                Al acceder y utilizar este producto, aceptas estar sujeto a
                estos términos y condiciones, todas las leyes y regulaciones
                aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3487">
                2. Uso del Servicio
              </h3>
              <p data-id="element-3488">
                El contenido proporcionado es solo para fines educativos e
                informativos. No garantizamos resultados específicos de ingresos
                o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3489">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-3490">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor. No está permitida la reproducción o
                distribución sin autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3491">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-3492">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3493">Contacto</h3>
              <p data-id="element-3494">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-3495">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-3496">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-3497">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-3498">
              <X className="w-6 h-6" data-id="element-3499" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-3500">
              Política de Privacidad
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-3501">
              <p data-id="element-3502">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad. Esta política describe cómo recopilamos, usamos y
                protegemos tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3503">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-3504">
                Recopilamos información que nos proporcionas directamente,
                incluyendo información de compra y comunicaciones.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3505">
                2. Uso de la Información
              </h3>
              <p data-id="element-3506">
                Utilizamos tu información para proporcionar acceso al producto y
                soporte.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3507">
                3. Seguridad de Datos
              </h3>
              <p data-id="element-3508">
                Implementamos medidas de seguridad apropiadas para proteger tu
                información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3509">Contacto</h3>
              <p data-id="element-3510">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-3511">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Floating WhatsApp Button */}
      <WhatsAppButton data-id="element-3512" />
    </div>;
}